import { Button } from "../ui";
import { ArrowRight, CheckCircle } from "lucide-react";
import { URLS, PROGRAM_STATS, TRAINING_NAME, HERO_DESCRIPTION } from "../../constants";

export function HeroSection() {
  return (
    <section className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-50 to-gray-100 px-4">
      <div className="max-w-6xl mx-auto text-center">
        <div className="mb-8">
          <div className="inline-flex items-center px-3 py-2 sm:px-4 bg-black text-white rounded-full text-xs sm:text-sm mb-4 sm:mb-6 max-w-full">
            <CheckCircle className="w-3 h-3 sm:w-4 sm:h-4 mr-1 sm:mr-2 flex-shrink-0" />
            <span className="text-center leading-tight">
              <span className="block sm:inline">助成金活用で実質負担額</span>
              <span className="block sm:inline sm:ml-1">最大{PROGRAM_STATS.MAX_SUBSIDY_RATE}削減</span>
            </span>
          </div>
          <h1 className="mb-4 sm:mb-6 text-2xl sm:text-4xl md:text-6xl lg:text-7xl tracking-tight text-gray-900 leading-tight">
            <span className="block sm:inline">{TRAINING_NAME}</span>
          </h1>
          <p className="mb-6 sm:mb-8 text-sm sm:text-lg md:text-xl text-gray-600 max-w-4xl mx-auto leading-relaxed px-2 sm:px-0">
            {HERO_DESCRIPTION}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12 max-w-4xl mx-auto">
          <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-200">
            <div className="text-3xl mb-2 text-black">最大{PROGRAM_STATS.MAX_SUBSIDY_RATE}</div>
            <div className="text-sm text-gray-600">助成金適用率</div>
          </div>
          <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-200">
            <div className="text-3xl mb-2 text-black">{PROGRAM_STATS.MIN_COST_PER_PERSON}</div>
            <div className="text-sm text-gray-600">実質負担額/名</div>
          </div>
          <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-200">
            <div className="text-3xl mb-2 text-black">{PROGRAM_STATS.TOTAL_HOURS}</div>
            <div className="text-sm text-gray-600">研修時間（{PROGRAM_STATS.TOTAL_SESSIONS}）</div>
          </div>
        </div>

        <div className="flex flex-col gap-3 sm:flex-row sm:gap-4 justify-center items-center px-4 sm:px-0">
          <Button size="lg" className="w-full sm:w-auto bg-black hover:bg-gray-800 text-white px-6 sm:px-8 py-3 text-sm sm:text-base" asChild>
            <a href={URLS.CONTACT} target="_blank" rel="noopener noreferrer">
              お問い合わせ・資料請求
              <ArrowRight className="ml-2 h-4 w-4 sm:h-5 sm:w-5" />
            </a>
          </Button>
          <Button variant="outline" size="lg" className="w-full sm:w-auto border-black text-black hover:bg-black hover:text-white px-6 sm:px-8 py-3 text-sm sm:text-base">
            助成金活用条件を確認
          </Button>
        </div>
      </div>
    </section>
  );
}
